import { useState } from "react";
import StyledButton from "../atom/Button";
import MuiBlock from "../atom/MuiCustoms";
import PrepareFetch from "../helpers/PrepareFetch";
import { Alert, CircularProgress, Snackbar } from "@mui/material";

const LuckyNumberAgreementAcceptButton = ({promoId, callback, children, ...props}) => {
    const defaultErrorMessage = "Houve um problema ao efetuar o aceite do regulamento.";

    const [loading, setLoading] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [error, setError] = useState(false);
    const [ errorMessage, setErrorMessage ] = useState(defaultErrorMessage);

    const doAcceptAgreement = () => {
        const fetchData = PrepareFetch(`/proxy/services/apexrest/api/v1/luckynumber/promotions/${promoId}/agreement`,"POST",{
            "Content-Type": "application/json"
          },{});

        setLoading(true);
        setDisabled(true);

        try {
            fetch(fetchData.url, fetchData.options)
            .then(response => {
                if(response.status === 200) {
                    if(callback) {
                        setLoading(false);
                        setError(false);
                        setDisabled(false);
                        callback();
                    }
                } else {
                    setErrorMessage(defaultErrorMessage);
                    throw new Error(response.message);
                }                
            })
            .catch(error => {
                setLoading(false);
                setError(true);
                setDisabled(false);

                if(process.env.VERCEL_ENV !== "production") {
                    console.log(error);
                }
            });
        } catch (error) {
            setLoading(false);
            setError(true);
            setDisabled(false);
            
            if(process.env.VERCEL_ENV !== "production") {
                console.log(error);
            }
        } 
    };

    return (
        <MuiBlock style={{position: "relative"}}>
            <StyledButton disabled={disabled} onClick={doAcceptAgreement} {...props}>
                {children}
            </StyledButton>
            { loading && (
                <CircularProgress
                    size={24}
                    sx={{
                        color: "var(--color-white)",
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        margin: "-12px 0 0 -12px"
                    }}
                />
            )}
            { error && (
                <Snackbar open={error} autoHideDuration={6000} onClose={() => setError(false)} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                    <Alert onClose={() => setError(false)} severity="warning" sx={{ width: '100%' }}>
                        {errorMessage}
                    </Alert>
                </Snackbar>
            )}
        </MuiBlock>
    )
};

export default LuckyNumberAgreementAcceptButton;